import React from "react";
import { Typography, TextField } from "@material-ui/core";
import useTranslatedValue from "../../../../hooks/useTranslatedValue";
import useAnswerQuestion from "../../hooks/useAnswerQuestion";
import useQuestionStyles from "./questionStyles";
import { CharacterCount } from "../../../common/input/CharacterCount";

export const TextQuestion = ({ question, isDisabled, followUpUUID }) => {
    const classes = useQuestionStyles();
    const getTranslatedValue = useTranslatedValue();
    const answerQuestion = useAnswerQuestion();

    const currentValue = question.value ?? "";
    const maxLength = question.props.max || 2000;
    const characterCount = currentValue.length;

    return (
        <>
            <Typography variant="body1" className={classes.questionText}>
                {question.mandatory && <span className={classes.mandatory}>*</span>}
                {getTranslatedValue(question.questionText)}
            </Typography>
            <TextField
                fullWidth
                variant="outlined"
                name={question.name}
                value={currentValue}
                onChange={(e) => answerQuestion(e.target.value, question, followUpUUID)}
                disabled={isDisabled || question.isDisabled}
                label={getTranslatedValue(question.tooltip)}
                required={question.mandatory}
                InputLabelProps={{
                    className: classes.inputLabel,
                }}
                InputProps={{
                    className: classes.input,
                    inputProps: { maxLength: maxLength },
                }}
            />
            <CharacterCount characterCount={characterCount} maxLength={maxLength} />
        </>
    );
};
export default TextQuestion;
